import React, { useEffect, useState } from "react";
import styles from "./astrologertarotcer.module.css";
import { Box, Button, LinearProgress, Link, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import SessionModal from "../../components/Modal/SessionModal";
import ComingSoonModal from "../../components/Modal/ComingSoonModal";
import Head from "next/head";
import { useRouter } from 'next/router'
import NewBlockHeader from "../../components/NewBlockHeader/NewBlockHeader";
import Image from "next/image";
import styles1 from "../../pages/diviner-signup/payment.module.css";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";

export default function Index() {
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [open, setOpen] = useState(false);
    const [quater_id, setQuater_id] = useState('')
    const [firstQuaterClick, setFirstQuaterClick] = useState(false)
    const [seduledata, setSeduledata] = useState({})
    const [sessionMOdalOpen, setSessionMOdalOpen] = useState(false)

    const route = useRouter()


    const ScrollSession = () => {


        route.push('/diviner-signup')
    }

    const Scrolltomatrix = () => {
        let viewElement = document.getElementById('ATC_block5')
        viewElement.scrollIntoView({ behavior: "smooth" })
    }


    useEffect(() => {
        console.log("route======>", route.query.coursesmetrics);
        if (route.query.coursesmetrics == '' && route.route == "/tarot-astrology-certification") {
            console.log("asdag", route);
            let viewElement = document.getElementById('click_here_tag_block')
            viewElement.scrollIntoView({ behavior: "smooth" })
        }
    }, [route])

    const [showOtherBlocks, setShowOtherBlocks] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowOtherBlocks(true);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    const isMobile = useMediaQuery('(max-width:600px)');
    const isTablet = useMediaQuery('(min-width:601px) and (max-width:900px)');

    let logoBanner = '/image/logobanner_desktop.webp';

    if (isMobile) {
        logoBanner = '/image/logobanner.webp';
    } else if (isTablet) {
        logoBanner = '/image/logobanner.webp';
    }





    return (
        <>

            <>
                <link
                    rel="preload"
                    href="/image/ATC_bannerBG3.webp"
                    as="image"
                    type="image/webp"
                />
                <link
                    rel="preload"
                    href="/image/ATC_bannerBG2_new.webp.webp"
                    as="image"
                    type="image/webp"

                />
                <link
                    rel="preload"
                    href="/image/ATC_bannerBG1.webp"
                    as="image"
                    type="image/webp"
                />
                <link
                    rel="preload"
                    href="/image/ATC_bannerBG1_mobile.webp"
                    as="image"
                    type="image/webp"

                />

                <link
                    rel="preload"
                    href="/image/logobanner_cropped.webp" as="image" type="image/webp"

                />

                <link
                    rel="preload"
                    href="/image/as_right_green_bg2.webp" as="image" type="image/webp"

                />


            </>

            <Head>
                <title>Tarot & Astrology Certification Course | School of Our Divine Infinite Being</title>
                <meta name="description" content="Embark on a journey to become a certified divination consultant with our comprehensive Tarot and Astrology Certification. Gain expertise, practice extensively, and prepare for a rewarding career in divination. Enroll now to transform your passion into a profession!"></meta>
                <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
                <meta name="keywords" content="tarot certification, astrology certification, divination training, tarot course, astrology course, professional divination consultant, tarot reading, astrology reading"></meta>
                <meta property="og:title" content="Tarot & Astrology Certification Course | School of Our Divine Infinite Being"></meta>
                <meta property="og:type" content="website" ></meta>
                <meta property="og:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/astro_tarot_og_img.webp"></meta>
                <meta property="og:url" content="https://www.divineinfinitebeing.com/tarot-astrology-certification"></meta>
                <meta property="og:description" content="Embark on a journey to become a certified divination consultant with our comprehensive Tarot and Astrology Certification. Gain expertise, practice extensively, and prepare for a rewarding career in divination. Enroll now to transform your passion into a profession!"></meta>
                <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/astro_tarot_og_img.webp"></meta>
                <meta name="twitter:card" content="summary_large_image"></meta>
                <meta property="twitter:title" content="Tarot & Astrology Certification Course | School of Our Divine Infinite Being"></meta>
                <meta property="twitter:url" content="https://www.divineinfinitebeing.com/tarot-astrology-certification"></meta>
                <meta property="twitter:description" content="Embark on a journey to become a certified divination consultant with our comprehensive Tarot and Astrology Certification. Gain expertise, practice extensively, and prepare for a rewarding career in divination. Enroll now to transform your passion into a profession!"></meta>
                <meta property="og:image:width" content="1200"></meta>
                <meta property="og:image:height" content="627"></meta>
                <meta property="og:url" content="https://www.divineinfinitebeing.com/tarot-astrology-certification"></meta>
                <meta property="og:image:alt" content="Tarot cards and astrological symbols arranged in a mystical setting, representing divination and celestial wisdom." />

                <link rel="canonical" href="https://www.divineinfinitebeing.com/tarot-astrology-certification" />

                <style>
                    {`
            .astrologertarotcer_atcblockone__g_T1V {
    background: url(/image/ATC_bannerBG3.webp), url(/image/ATC_bannerBG2_new.webp.webp), url(/image/ATC_bannerBG1.webp);
    background-size: 100% 100%, auto 153%, 100% 100%;
    background-position: top right, right -750px bottom -220px, center center;
    background-repeat: no-repeat;
    border-radius: 0;
    
    padding: 0 0 26px;
    margin-bottom: 0;
    min-height: 1px;
    border-top: 1px solid #000;
    contain: paint;
}

.astrologertarotcer_gradent_right_bg2__nmdfB {
    background: url(/image/as_right_green_bg2.webp);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: left top;
    overflow: hidden;
    padding: 12px;
}

@media screen and (max-width: 1899px) {
    .astrologertarotcer_atcblockone__g_T1V {
        background-size: 100% 100%, 2420px, 100% 100%;
        background-position: top right, right -870px bottom -235px, center center;
    }
}
    @media screen and (max-width: 1199px) {
    .astrologertarotcer_atcblockone__g_T1V {
        background: url(/image/ATC_bannerBG1_mobile.webp);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: left center;
                margin-top: -20px;
    }
}
            `}
                </style>
            </Head>




            <div className={`${styles.atcblockone} atcblockBanner`}>
                {/* <!------Main Banner section-------> */}
                <div className={styles.atcwrapper}>
                    <div className={styles.atcblockone_flx_wrapper}>
                        <div className={styles.atcblockoneleft}>
                            {/* <span className={styles.bannerLogo}>
                                <span className={styles.logoviewlink} alt={styles.viewicon} onClick={handleOpen}>

                                    <Image
                                        src="/image/viewicon.webp"
                                        alt="View Icon"
                                        width={400}
                                        height={100}
                                        style={{ width: '100%', height: 'auto' }}
                                        loading="lazy"
                                        placeholder="blur"
                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                                    />
                                </span>

                                <Image
                                    src="/image/logobanner_cropped.webp"
                                    alt="School of Our Divine Infinite Being Logo"
                                    width={332}
                                    height={332}
                                    style={{ width: '100%', height: 'auto' }}
                                    loading="lazy"
                                    layout="responsive"
                                    placeholder="blur"
                                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                                />
                            </span> */}
                            <div className="bannerLogo">
                <div className="bnnr_img1"> <span className="logoviewlink" onClick={handleOpen}>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /> */}
                  <img
                    src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                    alt="view_icon"
                  />
                </span>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" /> */}
                  <img
                    src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                    alt="banner_logo"
                  /></div>
                <div className="bnnr_img2"><img className="astrologypro_bnnr_logo"
                  src="/image/astrologypro/astrologupro_new_logo_bnnr.webp"
                  alt="AstrologyPro" />
                </div>
              </div>
                            <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
                            <h1 data-text="infinite being">INFINITE BEING</h1>
                            <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
                            <div className={`${styles.rotathewheelbottombannerbg} ${styles.bannerboxtxt}`}>
                                {/* <p> 238 hours of live classroom time | 38 hours of divinatory practice (reading for others) | Training on 15 programs!</p> */}
                                <p>Get access to over a hundred hours in intensive video training and 30 hours of live classroom time for divinatory practice (reading for others) | This includes full training on 15 offered session programs in Tarot and Astrology!</p>
                            </div>
                            <h3>Our training will give you the confidence and experience to read Astrology and Tarot and charge for your services. We assist graduates in client acquisition after they graduate!  Being a Diviner is a REAL CAREER.</h3>
                        </div>
                        <div className={styles.atcblockone_right}>
                            <div className={styles.gradent_right_bg1}>
                                <div className={styles.gradent_right_bg2}>
                                    <h3>Earn between <span>$50</span> to <span>$100</span> an hour as a professional Divination Consultant. We have Both<b> Video and Live Training!</b> </h3>
                                </div>
                            </div>
                            <div className={styles.gradent_right_button}>
                                <Button onClick={() => ScrollSession()}><span> Get Started Now  </span></Button>
                                <Button onClick={() => Scrolltomatrix()}>Click here for <span> class syllabus</span></Button>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

            <MysteryBannerNew/>

            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', pt: '35px', background: 'url(/image/ATC_block1BG1.webp) no-repeat center top / cover, #000' }}>
                {/* <div className={styles.connectedAccessBanner}>
                    <div className={styles.connectedAccessContent}>
                        <h5>
                            <VerifiedUserIcon /> CONNECTED ACCESS
                        </h5>
                        <p>
                            <strong>
                                Your Diviner Academy certification also unlocks your AstrologyPro access.
                                When you enroll, your journey seamlessly integrates into the connected
                                AstrologyPro experience.
                            </strong>
                        </p>
                        <Button className={styles.bannerActionButton} onClick={() => ScrollSession()}>
                            <span>Join Diviner Academy</span>
                        </Button>
                    </div>
                    <div className={styles.bannerSeparator}></div>
                    <div className={styles.connectedAccessLogo}>
                        <img
                            src="/image/astrologypro/astrologypro-logo.png"
                            alt="AstrologyPro Logo"
                        />
                    </div>
                </div> */}
                <div className={styles.common_width_extr}>
                <div className={styles1.connectedAccessBanner}>
                
                            <div className={styles1.connectedAccessContent}>
                              <h5>
                                 <span>CONNECTED ACCESS</span>
                              </h5>
                              <p>
                                <span className={styles1.grey_txt}>
                                   Your Diviner Academy certification also unlocks your AstrologyPro access.
                                </span> <span className={styles1.red_txt}>When you enroll,</span> <span className={styles1.grey_txt}>your journey seamlessly integrates into the connected AstrologyPro experience.</span>
                                
                              </p>
                              <Button className={styles.bannerActionButton} onClick={() => ScrollSession()}>
                                 <span>Join Diviner Academy</span>
                              </Button>
                            </div>
                
                            <div className={styles1.connectedAccessLogo}>
                              <img
                                src="/image/astrologypro/astrologypro_logo_img_new.webp"
                                alt="AstrologyPro Logo"
                              />
                            </div>
                            
                          </div>
                          </div>
            </Box>

            {/* <MysteryBannerNew /> */}

            <div className={styles.ATC_block1}>
                <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                    <span className={styles.column}>
                        <div className={`${styles.col12} ${styles.bgifive}`}>
                            <h1>ASTROLOGY AND TAROT CONSULTING CERTIFICATION COURSE </h1>
                        </div>
                    </span>
                </div>
                <div className={styles.common_width}>
                    <div className={styles.ATC_B1_sub}>

                        <Image
                            src="/image/ATC_block1_Astrology_new_image.webp"
                            alt="View Icon"
                            width={400}
                            height={100}
                            style={{ width: '100%', height: 'auto' }}
                            priority={true}
                            placeholder="blur"
                            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                            sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 400px"
                        />
                        <p>Graduates get access to an incredible set of tools to market themselves as well as take new clients from our own outreach programs! <span> This is a CAREER and we are the school that will prepare you to make an incredible living as a professional divination consultant!</span></p>
                    </div>
                    <div className={styles.ATC_B1_headder_main}>
                        <div className={styles.B1_header_border}>
                            <div className={styles.B1_header}>
                                <div className={styles.B1_sub_header_border}>
                                    <div className={styles.B1_sub_header_wrpr}>
                                        <h1>You will be learning all 15 of the following <span>Astrology</span> and <span>Tarot</span> consultation programs with the opportunity to practice with instructors and other students!</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.ATC_block2}>
                <div className={styles.common_width_extr}>
                    <div className={styles.ATC_block2_wrpr}>
                        <div className={styles.ATC_B2_product}>
                            <div className={styles.ATC_B2_product_Header}>
                                <h1>ASTROLOGY CONSULTING PROGRAMS</h1>
                            </div>
                            <div className={styles.ATC_B2_product_table}>
                                <div className={`${styles.ATC_B2_product_table_Common} ${styles.ATC_B2_product_table_left}`}>
                                    <ul>
                                        <li>Natal Chart</li>
                                        <li>Solar Return</li>
                                        <li>Monthly Transit (Included a Lunar return)</li>
                                        <li>Weekly Transits</li>
                                    </ul>
                                </div>
                                <div className={`${styles.ATC_B2_product_table_Common} ${styles.ATC_B2_product_table_right}`}>
                                    <ul>
                                        <li>Romantic Relationships</li>
                                        <li>Friendship Relationships</li>
                                        <li>Business Relationships</li>
                                        <li>Predictive Event (Horary)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className={styles.ATC_B2_product}>
                            <div className={styles.ATC_B2_product_Header}>
                                <h1>TAROT CONSULTING PROGRAMS</h1>
                            </div>
                            <div className={styles.ATC_B2_product_table}>
                                <div className={`${styles.ATC_B2_product_table_Common} ${styles.ATC_B2_product_table_left}`}>
                                    <ul>
                                        <li>3 Card Basic Question Spread</li>
                                        <li>5 Card Complex Question Spread</li>
                                        <li>7 Card 6 month forward review</li>
                                        <li> 7 Card Horseshoe Spread (Major read)</li>
                                    </ul>
                                </div>
                                <div className={`${styles.ATC_B2_product_table_Common} ${styles.ATC_B2_product_table_right}`}>
                                    <ul>
                                        <li>10 Card Relationship Spread</li>
                                        <li>10 Card Celtic Cross (Major read)</li>
                                        <li>12 Card Astrological Spread (Major read)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.common_width} id="click_here_tag_block">
                    <div className={styles.common_header}>
                        <div className={styles.common_header_wrpr}>
                            <h1><span onClick={() => ScrollSession()}>click here</span>  to choose your quarter and get started right away</h1>
                        </div>
                    </div>
                </div>
            </div>


            <div id="ATC_block2" className={styles.ATC_block2_1}>
                <div className={styles.common_width}>
                    <div className={styles.ATC_block2_1_wrpr}>
                        <p>Becoming really good at <span> Astrology </span> and <span> Tarot </span> takes true interaction.  This is not just some set of videos that you get a user and pass too we are a REAL SCHOOL. The following are the metrics of our courses.</p>
                        <h1 className={styles.Orange_header}>Courses Metrics:</h1>
                        <div className={styles.ATC_B2_1_miniBlock}>
                            <ul>
                                <li>Comprehensive and rigorous training encompassing over 100 hours of in-depth study, including both academic content and practical demonstrations by seasoned professionals. Our evaluative process allows for unlimited attempts at the examination, facilitating mastery through iterative improvement.</li>
                                <li>Upon successful completion of the training modules and certification exam, participants may choose live classroom sessions that align with their personal schedules.</li>
                                <li>The curriculum is structured into two-week segments, Session A and Session B, each providing 30 hours of immersive, live classroom engagement and active practice alongside fellow students.</li>
                                <li>Participants will have the opportunity to conduct over 20 live readings during these sessions, ensuring they gain confidence and proficiency in the application of their skills.</li>
                                <li>All training sessions are meticulously recorded, allowing students to revisit and analyze a plethora of readings conducted by peers, thereby enhancing their learning curve.</li>
                                <li>Direct access to our expert instructors is facilitated through both email correspondence and scheduled one-on-one consultations, ensuring personalized guidance and support.</li>
                            </ul>
                        </div>
                    </div>
                    {/* <h2>You are able to choose from two different sessions during the quarter that best suits your time and availability.</h2> */}
                </div>
            </div>



            <div className={styles.ATC_new_block_part1}>
                <div className={styles.common_width}>
                    <div className={`${styles.ATC_new_block_common_header_wrpr}  newBlockWrpr`}>
                        <div className={styles.ATC_new_block_main_wrpr}>
                            <div className={styles.ATC_new_block_left_sec}>
                                <h2>Our courses are done through live web casts, student center training videos and several opportunities to read for other students. You will be able to collaborate live with teachers and go into break out seasons with other students while enjoying full course materials you gain access to for life!</h2>
                                <div className={styles.ATC_new_block_left_orange_box}>
                                    <h3>We are currently taking students for <span>our 2025 year grand opening</span>. You can sign up anytime and will gain access to the training center on <span>December 21st, 2025</span>.</h3>
                                </div>
                                <h2>Due to live training schedules seats are limited so if you are interested we suggest you get <strong>signed up early!</strong></h2>
                            </div>
                            <div className={styles.ATC_block4_button}>
                                <Link href="/diviner-signup" onClick={() => route.push("/diviner-signup")}><span>Get Started Now</span></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className={styles.ATC_block5} id="ATC_block5">
                <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                    <span className={styles.column}>
                        <div className={`${styles.col12} ${styles.bgifive}`}>
                            <h1>our 24 Week classroom syllabus</h1>
                        </div>
                    </span>
                </div>
                <div className={styles.common_width}>

                    <div className={styles.astro_curri_wrpr}>
                        <h2>Astrology Curriculum</h2>
                        <div className={styles.yellow_bg}></div>
                    </div>



                    {/* -------------------------------block1--------------------- */}
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec1_main}`} >

                        <img src="/image/astro_img.webp" className={styles.abs_astro_img} alt="astro_img" />

                        <div className={`${styles.foa_w} ${styles.font}`}><h2><span> Foundations of Astrology </span> </h2></div>

                        <div className={`${styles.hoa_w} ${styles.font}`}><h3> History of Astrology:</h3></div>

                        <div className={styles.syll_para}>
                            <p>Explore the origins and evolution of astrology through various cultures and epochs.</p>
                        </div>

                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Ancient Beginnings</h5>
                                <ul>

                                    <li >Discover the origins of astrology in Mesopotamia and Babylon, including the creation of the zodiac.</li>
                                    <li>Explore its early use for divination and celestial observation.</li>


                                </ul>
                            </div>


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Medieval and Renaissance Revival</h5>
                                <ul>

                                    <li >Study the resurgence of astrology in Europe through translations of classical texts.</li>
                                    <li>Explore its role in Renaissance thought and esoteric traditions.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Cultural Expansion</h5>
                                <ul>

                                    <li >Study the resurgence of astrology in Europe through translations of classical texts.</li>
                                    <li>Explore its role in Renaissance thought and esoteric traditions.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Modern Developments</h5>
                                <ul>

                                    <li >Examine the 19th-century revival through spiritualism and psychological astrology.</li>
                                    <li>Learn how astrology evolved into a modern practice embraced in contemporary culture.</li>


                                </ul>
                            </div>





                        </div>



                    </div>


                    {/* -------------------------------block1--------------------- */}




                    {/* -------------------------------block2--------------------- */}
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec2_main}`} >

                        <img src="/image/PoA_img.webp" className={styles.abs_astro_img} alt="PoA_img" />

                        {/* <div className={`${styles.foa_w} ${styles.font}`}><h2><span> Foundations of Astrology </span> </h2></div> */}

                        <div className={`${styles.hoa_w} ${styles.font}`}><h3> Proof of Astrology:</h3></div>

                        <div className={styles.syll_para}>
                            <p>Examine evidence and historical proofs supporting astrological practices.</p>
                        </div>

                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Foundations and Evidence</h5>
                                <ul>

                                    <li >Explore the scientific, statistical, and philosophical arguments validating astrology.</li>
                                    <li>Understand astrology's predictive accuracy and its correlation with human traits and events.</li>


                                </ul>
                            </div>


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Connections to Modern Science</h5>
                                <ul>

                                    <li >Discover parallels between astrology, psychology, and parapsychology.</li>
                                    <li>Understand concepts like synchronicity and archetypes in supporting astrological principles.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Cultural Expansion</h5>
                                <ul>

                                    <li >Examine studies like the Mars Effect and their data-driven significance.</li>
                                    <li>Learn how astrology has guided leaders and predicted major historical events.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Philosophical and Critical Perspectives</h5>
                                <ul>

                                    <li >Discuss astrology's deeper connection to the cosmos and human destiny.</li>



                                </ul>
                            </div>





                        </div>



                    </div>


                    {/* -------------------------------block2--------------------- */}






                    {/* -------------------------------block3--------------------- */}
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec3_main}`} >

                        <img src="/image/DPA_imge.webp" className={styles.abs_astro_img} alt="DPA_imge" />

                        <div className={`${styles.foa_w} ${styles.font}`}><h2><span> Developing Psychic Abilities</span> </h2></div>

                        <div className={`${styles.hoa_w} ${styles.font}`}><h3>How to Be Psychic:</h3></div>

                        <div className={styles.syll_para}>
                            <p>Learn techniques to harness and develop your intuitive senses.</p>
                        </div>

                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Foundations of Psychic Development</h5>
                                <ul>

                                    <li >Explore the principles of open-mindedness and belief as a foundation for psychic growth.</li>
                                    <li>Understand the importance of trust, patience, and critical thinking in intuitive exploration.</li>


                                </ul>
                            </div>


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Strengthening Psychic Senses</h5>
                                <ul>

                                    <li >Enhance extrasensory perception (e.g., clairvoyance, clairaudience, clairsentience) through targeted exercises.</li>
                                    <li>Explore energy work techniques, including chakra balancing, aura reading, and grounding.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Techniques for Intuitive Awareness</h5>
                                <ul>

                                    <li >Learn practices such as meditation, mindfulness, and dream journaling to deepen connection with intuition.</li>
                                    <li>Develop heightened awareness of subtle energies and symbolic patterns in daily life.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Practical Tools and Applications</h5>
                                <ul>

                                    <li >Discover how to use crystals, tarot cards, and other tools to amplify intuitive abilities.</li>
                                    <li>Learn to interpret signs, symbols, and synchronicities as part of intuitive guidance.</li>


                                </ul>
                            </div>





                        </div>



                    </div>


                    {/* -------------------------------block3--------------------- */}






                    {/* -------------------------------block4--------------------- */}
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec4_main}`} >

                        <img src="/image/IPA_img.webp" className={styles.abs_astro_img} alt="IPA_img" />

                        {/* <div className={`${styles.foa_w} ${styles.font}`}><h2><span> Foundations of Astrology </span> </h2></div> */}

                        <div className={`${styles.hoa_w} ${styles.font}`}><h3> How to Increase Psychic Abilities</h3></div>

                        <div className={styles.syll_para}>
                            <p>Discover methods to strengthen your psychic skills and sensitivity.</p>
                        </div>

                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Deepening Intuitive Awareness</h5>
                                <ul>

                                    <li >Explore techniques to heighten perception, including advanced meditation, mindfulness, and energy awareness.</li>
                                    <li>Learn to identify and interpret intuitive signals with greater clarity.</li>


                                </ul>
                            </div>


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Harnessing Energy for Growth</h5>
                                <ul>

                                    <li >Master energy work techniques like chakra alignment, grounding, and energy field cleansing.</li>
                                    <li>Explore practices such as Reiki, Qi Gong, and sound healing to increase sensitivity and flow.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Expanding Psychic Senses</h5>
                                <ul>

                                    <li >Strengthen clairvoyance, clairaudience, and clairsentience through focused exercises.</li>
                                    <li>Practice remote viewing, aura reading, and psychometry to enhance extrasensory perception.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Integrating Tools and Techniques</h5>
                                <ul>

                                    <li >Use divination tools like tarot cards, pendulums, and crystals to enhance intuitive focus.</li>
                                    <li>Recognize patterns, symbols, and synchronicities to expand intuitive understanding in everyday life.</li>


                                </ul>
                            </div>





                        </div>



                    </div>


                    {/* -------------------------------block4--------------------- */}





                    {/* -------------------------------block5--------------------- */}
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec5_main}`} >

                        <img src="/image/AS_img.webp" className={styles.abs_astro_img} alt="AS_img" />

                        <div className={`${styles.foa_w} ${styles.font}`}><h2><span> Astrological Systems</span> </h2></div>

                        <div className={`${styles.hoa_w} ${styles.font}`}><h3> Introduction to Astrology</h3></div>

                        <div className={styles.syll_para}>
                            <p>A beginner’s guide to understanding astrology's core principles.</p>
                        </div>

                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>What is Astrology?</h5>
                                <ul>

                                    <li >Understand astrology as a system that bridges cosmic rhythms with personal and collective experiences.</li>
                                    <li>Learn about the history and cultural significance of astrology across civilizations.</li>


                                </ul>
                            </div>


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>How Astrology Works</h5>
                                <ul>

                                    <li >Discover how a natal chart is created using date, time, and location of birth.</li>
                                    <li>Learn how planetary positions, signs, and houses interact to shape an individual’s life and personality.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>The Building Blocks of Astrology</h5>
                                <ul>

                                    <li >Introduction to the zodiac wheel, its 12 signs, and their symbolic meanings.</li>
                                    <li>Overview of planets, houses, and aspects as the key components of a natal chart.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Applications of Astrology</h5>
                                <ul>

                                    <li >Explore the practical uses of astrology, including personality analysis, relationship insights, and life guidance.</li>
                                    <li>Understand the difference between natal astrology, predictive astrology, and compatibility assessments.</li>


                                </ul>
                            </div>





                        </div>



                    </div>


                    {/* -------------------------------block5--------------------- */}




                    {/* -------------------------------block6--------------------- */}
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec6_main}`} >

                        <img src="/image/SiA_img.webp" className={styles.abs_astro_img} alt="SiA_img" />

                        {/* <div className={`${styles.foa_w} ${styles.font}`}><h2><span> Foundations of Astrology </span> </h2></div> */}

                        <div className={`${styles.hoa_w} ${styles.font}`}><h3>Signs in Astrology</h3></div>

                        <div className={styles.syll_para}>
                            <p>Study the 12 zodiac signs and their unique characteristics.</p>
                        </div>

                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>The Zodiac as a Cosmic Framework</h5>
                                <ul>

                                    <li >Discover how the 12 signs form the foundation of astrological interpretation.</li>
                                    <li>Explore their connection to the natural elements and cycles of life.</li>


                                </ul>
                            </div>


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Sign Archetypes and Traits</h5>
                                <ul>

                                    <li >Explore the symbolic essence and core characteristics of each zodiac sign.</li>
                                    <li>Understand how these archetypes manifest in behavior and personality.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>The Elements and Modalities</h5>
                                <ul>

                                    <li >Learn about the four elements—Fire, Earth, Air, and Water—and how they influence the zodiac.</li>
                                    <li>Understand the three modalities—Cardinal, Fixed, and Mutable—and their role in defining each sign’s approach to life.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Astrological Insights</h5>
                                <ul>

                                    <li >Learn how the signs contribute to self-awareness and interpersonal dynamics.</li>
                                    <li>Gain a broad understanding of their influence on relationships, career, and growth.</li>


                                </ul>
                            </div>





                        </div>



                    </div>


                    {/* -------------------------------block6--------------------- */}




                    {/* -------------------------------block7--------------------- */}
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec7_main}`} >

                        <img src="/image/HiA_img.webp" className={styles.abs_astro_img} alt="HiA_img" />



                        <div className={`${styles.hoa_w} ${styles.font}`}><h3> Houses in Astrology</h3></div>

                        <div className={styles.syll_para}>
                            <p>Understand the astrological houses and their influence on different life aspects.</p>
                        </div>

                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={styles.tarot_Divide_Sec_coloum}>
                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>The Framework of the Houses</h5>
                                    <ul>

                                        <li >Discover how the 12 houses form the foundation of an astrological chart.</li>
                                        <li>Learn how the houses reflect life’s diverse aspects, from self-identity to relationships and spirituality.</li>


                                    </ul>
                                </div>


                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Themes and Areas of Life</h5>
                                    <ul>

                                        <li >Explore the unique focus of each house, such as:</li>
                                        <sub><span> First House:</span> Self and identity.</sub>
                                        <sub><span> Fourth House:</span> Home and emotional foundations.</sub>
                                        <sub><span> Tenth House:</span> Career and public image.</sub>
                                        <li>Understand how the houses collectively create a complete picture of life’s journey.</li>


                                    </ul>
                                </div>

                            </div>


                            <div className={styles.tarot_Divide_Sec_coloum}>


                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>The Relationship Between Signs and Houses</h5>
                                    <ul>

                                        <li >Learn how zodiac signs influence the houses they occupy.</li>
                                        <li>Discover how the interplay of signs and houses personalizes astrological readings.</li>


                                    </ul>
                                </div>



                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Planetary Placement in Houses</h5>
                                    <ul>

                                        <li >Gain an understanding of how planets energize and modify the themes of the houses they occupy.</li>
                                        <li>Explore how planetary placements can reveal personality traits, challenges, and opportunities.</li>


                                    </ul>
                                </div>

                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Astrological Interpretation</h5>
                                    <ul>

                                        <li >Develop the skills to interpret how houses contribute to a natal chart’s overall meaning.</li>
                                        <li>Learn how house cusps and planetary alignments influence life’s dynamics.</li>


                                    </ul>
                                </div>

                            </div>









                        </div>



                    </div>


                    {/* -------------------------------block7--------------------- */}







                    {/* -------------------------------block8--------------------- */}
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec8_main}`} >

                        <img src="/image/AiA_img.webp" className={styles.abs_astro_img} alt="AiA_img" />

                        {/* <div className={`${styles.foa_w} ${styles.font}`}><h2><span> Foundations of Astrology </span> </h2></div> */}

                        <div className={`${styles.hoa_w} ${styles.font}`}><h3> Aspects in Astrology</h3></div>

                        <div className={styles.syll_para}>
                            <p>Analyze the relationships and angles between planets in a natal chart.</p>
                        </div>

                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />
                            <div className={styles.tarot_Divide_Sec_coloum}>
                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Introduction to Aspects</h5>
                                    <ul>

                                        <li >DUnderstand what aspects are and their significance in astrology.</li>
                                        <li>Learn how aspects reflect planetary relationships and influence the chart’s overall energy.</li>


                                    </ul>
                                </div>

                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>The Major Aspects</h5>
                                    <ul>

                                        <li >Explore the core aspects and their meanings:</li>
                                        <sub><span>Conjunction:</span> Unified energy and focus.</sub>
                                        <sub><span>Opposition:</span> Tension and balance between polarities.</sub>
                                        <sub><span>Trine:</span> Harmonious and effortless flow.</sub>
                                        <sub><span>Square:</span> Challenges that foster growth. </sub>
                                        <sub><span>Sextile:</span> Opportunities through cooperation.</sub>




                                    </ul>
                                </div>

                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>The Minor Aspects</h5>
                                    <ul>

                                        <li >Discover additional subtle aspects that provide deeper layers of interpretation:</li>
                                        <sub><span>Quincunx:</span> Adjustments and realignment.</sub>
                                        <sub><span>Semisextile:</span> Small opportunities and nuances. </sub>





                                    </ul>
                                </div>




                            </div>


                            <div className={styles.tarot_Divide_Sec_coloum}>

                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Orbs and Aspect Strength</h5>
                                    <ul>

                                        <li >Learn about orbs and how the degree of separation between planets impacts the strength of an aspect.</li>
                                        <li>Explore the difference between tight and wide aspects.</li>


                                    </ul>
                                </div>






                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Aspect Patterns</h5>
                                    <ul>

                                        <li >Understand how multiple aspects form patterns like the Grand Trine, T-Square, and Yod, and what these configurations reveal.</li>



                                    </ul>
                                </div>




                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Interpreting Aspects</h5>
                                    <ul>

                                        <li >Learn how aspects influence personality traits, life challenges, and opportunities.</li>
                                        <li>Understand how to balance conflicting energies and maximize harmonious alignments.</li>



                                    </ul>
                                </div>

                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Aspects in Practice</h5>
                                    <ul>

                                        <li >Explore how aspects evolve over time through transits, progressions, and synastry (relationship astrology).</li>
                                        <li>Discover practical applications of aspects in daily life and personal growth.</li>



                                    </ul>
                                </div>
                            </div>

















                        </div>



                    </div>


                    {/* -------------------------------block8--------------------- */}



                    {/* -------------------------------block9--------------------- */}
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec9_main}`} >

                        <img src="/image/PiA_img.webp" className={styles.abs_astro_img} alt="PiA_img" />

                        {/* <div className={`${styles.foa_w} ${styles.font}`}><h2><span> Foundations of Astrology </span> </h2></div> */}

                        <div className={`${styles.hoa_w} ${styles.font}`}><h3>Planets in Astrology</h3></div>

                        <div className={styles.syll_para}>
                            <p>Dive into the role and significance of planets in astrology.</p>
                        </div>

                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={styles.tarot_Divide_Sec_coloum}>
                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Planetary Archetypes</h5>
                                    <ul>

                                        <li >Understand the symbolic role of each planet as an archetype influencing human experiences, from communication and creativity to transformation and ambition.</li>
                                        <li>Explore how myths and legends shape the planets' astrological significance.</li>


                                    </ul>
                                </div>

                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Planetary Roles in Astrology</h5>
                                    <ul>

                                        <li >Discover how planets govern key areas of life and personality.</li>
                                        <li>Learn about planetary rulerships over zodiac signs and their unique expressions.</li>


                                    </ul>
                                </div>
                            </div>


                            <div className={styles.tarot_Divide_Sec_coloum}>
                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Cosmic Relationships</h5>
                                    <ul>

                                        <li >Gain insights into planetary alignments (e.g., conjunctions, trines, squares) and their influence on personal growth and relationships.</li>
                                        <li>Explore the dynamic interplay between planets in an astrological chart.</li>


                                    </ul>
                                </div>



                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Planetary Movements</h5>
                                    <ul>

                                        <li >Learn about transits and their impact on life events, opportunities, and challenges.</li>
                                        <li>Understand retrogrades as periods of reflection and realignment.</li>


                                    </ul>
                                </div>


                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Practical Insights</h5>
                                    <ul>

                                        <li >Use planetary energies to improve decision-making, communication, and self-awareness.</li>
                                        <li>Apply astrological knowledge to align with cosmic rhythms and achieve personal goals.</li>


                                    </ul>
                                </div>

                            </div>






                        </div>



                    </div>


                    {/* -------------------------------block9--------------------- */}



                    {/* -------------------------------------block12-------------------- */}


                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec12_main}`} >

                        <img src="/image/AA_img1.webp" className={styles.abs_astro_img} alt="AA1_img" />

                        {/* <div className={`${styles.foa_w} ${styles.font}`}><h2><span> Archetypal Astrology</span> </h2></div> */}
                        <div className={`${styles.hoa_w} ${styles.font}`}><h3>Archetypal Astrology</h3></div>


                        <div className={styles.syll_para}>
                            <p>Understanding Cosmic Patterns in Human Experience </p>
                            <p>Archetypal Astrology explores the universal patterns and symbolic themes that shape human experiences, emotions, and behaviors. This course delves into the deep connection between astrology and archetypes, revealing how planetary movements reflect collective and personal psychological dynamics.</p>
                            <p>Through a structured study of planetary archetypes, students will learn to decode astrological influences beyond technical chart analysis, applying a mythological and psychological perspective to astrology readings. This course provides insight into how ancient archetypes manifest in modern life, offering a richer, more intuitive approach to astrological interpretation.</p>
                        </div>

                        {/* <div className={`${styles.hoa_w} ${styles.font}`}><h3>  What You’ll Learn</h3></div> */}



                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                {/* <h5>Why The Gospel of Thomas</h5> */}
                                <ul>

                                    <li >The Foundations of Archetypal Astrology – Understand how planets, signs, and aspects embody timeless
                                        archetypal energies that shape human consciousness.</li>
                                    <li>Interpreting Archetypes in Astrological Readings – Learn how to recognize archetypal themes in birth charts and transits, revealing deep psychological patterns and life themes.</li>
                                    <li>Planetary Archetypes and Their Influence – Explore the mythological and psychological dimensions of Saturn (discipline and limitation), Venus (love and beauty), Mars (action and willpower), Neptune (illusion and transcendence), and more.</li>
                                    <li>Astrology, Mythology, and the Collective Unconscious – Discover the Jungian perspective on archetypes and how astrology reflects the collective unconscious through planetary alignments.</li>
                                </ul>
                            </div>




                        </div>

                        {/* <div className={`${styles.hoa_w} ${styles.font} ${styles.dobbul_grn_wrp}`}><h3>  Why Take This Course?</h3></div> */}
                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3>  Why Take This Course?</h3>
                        </div>





                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw} ${styles.block12_sec_blue_wrp}`} alt="Arrow Image" />


                            <div className={`${styles.learing_points} ${styles.lp_wdt} `} >
                                {/* <h5>Why The Gospel of Thomas</h5> */}
                                <ul>

                                    <li >Develop a deeper, intuitive approach to astrology, moving beyond technical interpretations.</li>
                                    <li>Learn to identify and work with archetypal energies in birth charts and transits.</li>
                                    <li>Understand how planetary archetypes shape personal and collective experiences.</li>
                                    <li>Gain insight into astrology’s connection to mythology, psychology, and the human journey.</li>
                                </ul>
                            </div>




                        </div>



                    </div>






                    {/* -------------------------------------block12-------------------- */}





                    {/* -------------------------------------block13-------------------- */}


                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec12_main} ${styles.astro_syllabus_sec13_main}`} >

                        <img src="/image/AR_img.webp" className={styles.abs_astro_img} alt="AR_img" />

                        {/* <div className={`${styles.foa_w} ${styles.font}`}><h2><span> Astrology Readings</span> </h2></div> */}
                        <div className={`${styles.hoa_w} ${styles.font}`}><h3> Astrology Readings</h3></div>


                        <div className={styles.syll_para}>
                            <p>Mastering the Art of Celestial Interpretation </p>
                            <p>This course offers a practical, real-world approach to astrology readings,
                                providing students with recorded real-life astrology sessions featuring actual
                                individuals. Through these live-recorded readings, students will witness
                                professional astrologers interpret charts in real time, demonstrating how
                                astrology applies to personal experiences, life events, and relationships.</p>
                            <p>Using our proprietary astrology software, students will gain hands-on experience in analyzing birth charts, planetary transits, relationship compatibility, and predictive techniques. This course focuses on eleven essential astrology readings, covering natal analysis, return charts, and predictive event forecasting to help students develop a well-rounded understanding of astrological interpretation.</p>
                        </div>

                        {/* <div className={`${styles.hoa_w} ${styles.font}`}><h3>  Course Overview</h3></div> */}
                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> Course Overview</h3>
                        </div>


                        {/* 
                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div> */}



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />

                            <div className={styles.tarot_Divide_Sec_coloum}>
                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>What You’ll Learn</h5>
                                    <ul>

                                        <li > Foundational Astrology: Understanding Birth and Natal Readings</li>
                                        <sub>Nativity Birth Chart – Learn to analyze an individual's natal chart, identifying key influences of the Sun, Moon, planets, houses, and aspects on
                                            personality and life path.</sub>
                                        <sub>Understand planetary dignities, elemental
                                            balances, and house rulerships to refine
                                            interpretations.</sub>





                                    </ul>
                                </div>

                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    {/* <h5>The Major Aspects</h5> */}
                                    <ul>

                                        <li >Relationship Astrology: Interpreting Compatibility and Dynamics</li>
                                        <sub>Romantic Relationship Readings – Learn how to use synastry (chart comparison) and composite charts to assess love, compatibility, and karmic bonds in relationships.</sub>
                                        <sub>Friendship Relationship Readings – Understand how planetary influences affect friendships, emotional connections, and social compatibility.</sub>
                                        <sub>Business Relationship Readings – Explore astrological factors in professional partnerships, team dynamics, and leadership   compatibility to enhance workplace harmony.</sub>





                                    </ul>
                                </div>



                            </div>

                            <div className={styles.tarot_Divide_Sec_coloum}>

                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >

                                    <ul>

                                        <li > Tracking Planetary Influences: Timing and Transits</li>
                                        <sub>Weekly Transits – Learn to assess how short-term planetary movements shape emotions, decision-making, and external circumstances.</sub>
                                        <sub>Monthly Transits + Lunar Return – Explore monthly astrological cycles and how the Lunar Return offers insights into emotional themes and energy shifts.</sub>
                                        <sub>Solar Return – Interpret the Solar Return chart, which outlines the major themes and influences of the coming year.</sub>





                                    </ul>
                                </div>

                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >

                                    <ul>

                                        <li >Predictive and Specialized Astrology Readings</li>
                                        <sub>Predictive Event (Horary Astrology) – Learn to answer specific life questions using Horary Astrology, which analyzes planetary placements at the time of inquiry.</sub>
                                        <sub>Jupiter Return – Understand the significance of Jupiter’s return, which occurs every 12 years, marking a phase of expansion, new opportunities, and personal growth.</sub>
                                        <sub>Saturn Return – Study the Saturn Return, which happens every 29 years and signifies a period of maturity, restructuring, and major life shifts.</sub>
                                        <sub>Mars Return – Learn how to interpret the Mars Return, which influences motivation, ambition, and energy levels, helping individuals navigate action-oriented phases in life.</sub>






                                    </ul>
                                </div>
                            </div>





                        </div>




                    </div>




                    {/* -------------------------------------block13-------------------- */}



                    {/* -------------------------------------block14-------------------- */}


                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec12_main} ${styles.astro_syllabus_sec14_main}`} >

                        <img src="/image/WTTC_img.webp" className={styles.abs_astro_img} alt="WTTC_img" />




                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3>Why Take This Course?</h3>
                        </div>





                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >

                                <ul>

                                    <li >Observe real-life astrology in action through recorded live readings with actual clients</li>
                                    <li>Gain hands-on experience using astrology software for accurate chart interpretation and forecasting. </li>
                                    <li>Master essential astrology techniques for interpreting natal charts, transits, and predictive returns.</li>
                                    <li>Enhance your ability to apply astrology for personal growth, career planning, and professional readings.</li>
                                    <li>Develop skills in relationship astrology, learning how to assess compatibility across love, friendship, and business settings.</li>
                                </ul>
                            </div>




                        </div>





                    </div>






                    {/* -------------------------------------block14-------------------- */}



                    {/* <div className={styles.ATC_new_block_part1}> */}
                    <div className={styles.new18Aug_main_block}>
                        <div className={`${styles.ATC_new_block_common_header_wrpr}  newBlockWrpr`}>
                            <div className={styles.ATC_new_block_main_wrpr}>
                                <div className={styles.ATC_new_block_left_sec}>
                                    <h2>Our courses are done through live web casts, student center training videos and several opportunities to read for other students. You will be able to collaborate live with teachers and go into break out seasons with other students while enjoying full course materials you gain access to for life!</h2>
                                    <div className={styles.ATC_new_block_left_orange_box}>
                                        <h3>We are currently taking students for <span>our 2025 year grand opening</span>. You can sign up anytime and will gain access to the training center on <span>December 21st, 2025</span>.</h3>
                                    </div>
                                    <h2>Due to live training schedules seats are limited so if you are interested we suggest you get <strong>signed up early!</strong></h2>
                                </div>
                                <div className={styles.ATC_block4_button}>
                                    <Link href="/diviner-signup" onClick={() => route.push("/diviner-signup")}><span>Get Enrolled Now</span></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}



                    {/* -------------------------------block10--------------------- */}
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec10_main}`} >

                        <img src="/image/TC_img.webp" className={styles.abs_astro_img} alt="TC_img" />

                        <div className={`${styles.foa_w} ${styles.font}`}><h2><span>Tarot Curriculum</span> </h2></div>

                        <div className={`${styles.hoa_w} ${styles.font}`}><h3>  Introduction to Tarot</h3></div>





                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>History of Tarot</h5>
                                <ul>

                                    <li >Trace the fascinating history and cultural significance of Tarot cards.</li>



                                </ul>
                            </div>


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Rota the Wheel</h5>
                                <ul>

                                    <li >Understand the symbolism of the Tarot wheel and its mystical associations.</li>



                                </ul>
                            </div>








                        </div>



                    </div>


                    {/* -------------------------------block10--------------------- */}



                    {/* ---------------------------------block15------------------------ */}

                    <div className={`${styles.astro_syllabus_sec15_main}`}>
                        {/* <img src="/image/block15_bg_img.webp" className={styles.abs_astro_img} alt="block15_bg_img" /> */}

                        <div className={styles.astro_syllabus_sec15_main_sub_sec}>
                            <div className={`${styles.hoa_w} ${styles.font}`}><h3>Mastering the Minor Arcana</h3></div>
                            <div className={styles.syll_para}>
                                <p>Unlocking the Secrets of the Numbered Tarot Cards</p>
                            </div>
                            <div className={styles.syll_para15_block_green}>
                                <p>Course Overview</p>
                            </div>
                            <div className={`${styles.syll_para} ${styles.syll_2para}`}>
                                <p>The <span>Minor Arcana</span> serves as the bridge between the grand spiritual themes of the Major Arcana and the tangible experiences of everyday life. This course explores the <span>Ace through Ten</span> of each suit, unveiling their elemental influences, numerological significance, and symbolic meanings. Students will learn how these cards represent different life stages, emotions,
                                    conflicts, and transformations, as well as how they <span>interact with the Major Arcana to create deeper narratives in a Tarot reading.</span>
                                </p>
                                <p>Unlike the <span>Court Cards (Page, Knight, Queen, and King)</span>—which focus on
                                    personality traits and archetypes—this course centers on the numbered cards, which <span>illustrate events, cycles, and challenges</span> that shape personal and spiritual development.</p>
                            </div>

                        </div>
                    </div>
                    <div className={styles.astro_syllabus_sec15_15A_main}>
                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>
                        <div className={styles.astro_syllabus_sec15_15A_sub_wrp}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />

                            <div className={`${styles.learing_points} ${styles.learing_points_block15_wrp}`} >
                                <h5>The Structure and Symbolism of the Minor Arcana (Ace to Ten)</h5>
                                <ul>

                                    <li >Learn how the <span>four suits—Wands, Cups, Swords, and Disks—represent different dimensions of life:</span></li>
                                    <div className={styles.astro_syllabus_sec15_15A_list_flx}>
                                        <sub><span>Wands (Fire):</span> Creativity, ambition, and action.</sub>
                                        <sub><span>Swords (Air):</span> Intellect, logic, and conflict resolution.</sub>
                                        <sub><span>Cups (Water):</span> Emotions, intuition, and relationships.</sub>
                                        <sub><span>Disks (Earth):</span> Material stability, finances, and physical well-being.</sub>

                                    </div>
                                    <li>Understand the <span>numerological journey</span> from the <span>initiating energy of the Aces</span> to <span>the culmination and completion of the Tens.</span></li>
                                    <li>Explore how the <span>progression of numbers</span> mirrors personal evolution and growth in different life areas.</li>



                                </ul>
                            </div>
                        </div>
                    </div>


                </div>

                {/* ---------------------------------block15------------------------ */}



                {/* --------------------------------block16--------------- */}

                <div className={styles.astro_syllabus_sec16_main_mainWrp}>
                    <div className={styles.common_width}>

                        <div className={styles.astro_syllabus_sec16_main}>
                            <div className={styles.astro_syllabus_sec16_left_main}>
                                <div className={`${styles.learing_points}  `} >
                                    <h5>The Connection Between the Minor and Major Arcana</h5>
                                    <ul>

                                        <li >Discover how each <span>Minor Arcana card is influenced by a Major Arcana archetype</span>, revealing deeper spiritual insights.</li>
                                        <li>Learn to recognize when a <span>Minor Arcana card echoes the energy of a Major Arcana card</span>, providing additional meaning in a Tarot spread.</li>
                                        <li>See how the <span>themes of the Major Arcana are broken down into smaller, more practical experiences</span> within the Minor Arcana.</li>

                                    </ul>
                                </div>
                            </div>

                            <div className={styles.astro_syllabus_sec16_right_main}>
                                <img src="/image/astro_syllabus_sec16_right_main_img.webp" alt="astro_syllabus_sec16_right_main_img" />
                            </div>

                        </div>
                    </div>
                </div>

                <div className={styles.astro_syllabus_sec17_main_mainWrp}>
                    <div className={styles.common_width}>

                        <div className={`${styles.astro_syllabus_sec16_main} ${styles.astro_syllabus_sec17_main}`}>


                            <div className={styles.astro_syllabus_sec16_right_main}>
                                <img src="/image/astro_syllabus_sec17_main_left_img.webp" alt="astro_syllabus_sec17_main_left_img" />
                            </div>

                            <div className={styles.astro_syllabus_sec16_left_main}>
                                <div className={`${styles.learing_points}  `} >
                                    <h5>Elemental and Astrological Influences</h5>
                                    <ul>

                                        <li >Understand how <span>elemental interactions</span> between cards affect their interpretation in a reading.</li>
                                        <li>Learn the <span>astrological correspondences</span> of the Minor Arcana and how planetary placements enhance or challenge the card’s message.</li>
                                        <li>Explore how astrological associations help refine timing and situational meanings in Tarot readings.</li>

                                    </ul>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>


                <div className={styles.astro_syllabus_sec18_main_mainWrp}>
                    <div className={styles.common_width}>

                        <div className={`${styles.astro_syllabus_sec16_main} ${styles.astro_syllabus_sec18_main}`}>

                            <div className={styles.astro_syllabus_sec16_left_main}>
                                <div className={`${styles.learing_points}  `} >
                                    <h5>Reading the Minor Arcana in Practice</h5>
                                    <ul>

                                        <li >Develop methods to <span>interpret the Minor Arcana within different Tarot spreads.</span></li>
                                        <li>Learn how <span>multiple Minor Arcana cards in a spread can indicate specific patterns or themes</span> in someone’s life.</li>
                                        <li>Understand how to integrate <span>both Minor and Major Arcana cards in a single reading</span> for greater depth and accuracy.</li>

                                    </ul>
                                </div>
                            </div>


                            <div className={styles.astro_syllabus_sec16_right_main}>
                                <img src="/image/astro_syllabus_sec18_main_flx_img_1new.webp" alt="astro_syllabus_sec18_main_flx_img" />
                            </div>



                        </div>

                    </div>
                </div>


                <div className={styles.astro_syllabus_sec19_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec15_15A_main} ${styles.astro_syllabus_sec19_main}`}>

                            <div className={styles.astro_syllabus_sec15_15A_sub_wrp}>
                                <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />

                                <div className={`${styles.learing_points} ${styles.learing_points_block15_wrp}`} >
                                    <h5>Why Take This Course?</h5>
                                    <ul>

                                        <li >Gain a <span>structured understanding of the Minor Arcana</span> without the complexity of Court Cards. </li>

                                        <li>Develop <span>confidence in interpreting number symbolism, elements, and astrological influences</span> in readings.</li>
                                        <li>Learn how to <span>connect the lessons of the Minor Arcana to the deeper archetypes of the Major Arcana</span> for richer Tarot interpretations.</li>
                                        <li>Master <span>practical reading techniques</span> to apply the Minor Arcana effectively in both personal and professional Tarot readings.</li>



                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className={styles.astro_syllabus_sec20_main_mainWrp}>
                    <div className={styles.common_width}>

                        <div className={`${styles.astro_syllabus_sec15_main} ${styles.astro_syllabus_sec20_main}`}>
                            <div className={styles.astro_syllabus_sec15_main_sub_sec}>
                                <div className={`${styles.hoa_w} ${styles.font}`}><h3>Mastering the Court Cards</h3></div>
                                <div className={styles.syll_para}>
                                    <p>Archetypes of Personality and Power in Tarot</p>
                                </div>
                                <div className={styles.syll_para15_block_green}>
                                    <p>Course Overview</p>
                                </div>
                                <div className={`${styles.syll_para} ${styles.syll_2para}`}>
                                    <p>The <span>Court Cards</span> of the Minor Arcana represent powerful <span>personality
                                        archetypes, psychological traits, and real-world individuals</span> encountered in life. This course explores the four Court Cards—<span>Knight, Queen, Prince, and Princess</span>—within each suit, revealing how they embody different
                                        expressions of their elemental energies.
                                    </p>
                                    <p>
                                        In addition to traditional Tarot interpretation, this course also explores the a<span>ssociation between the Court Cards and MBTI (Myers-Briggs Type
                                            Indicator) personality types</span>, providing deeper psychological insights into these influential figures in a reading.</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <div className={styles.astro_syllabus_sec21_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec15_15A_main} ${styles.astro_syllabus_sec21_main}`}>
                            <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                                <h3> What You’ll Learn </h3>
                            </div>
                            <div className={styles.astro_syllabus_sec15_15A_sub_wrp}>
                                <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />

                                <div className={`${styles.learing_points} ${styles.learing_points_block15_wrp}`} >
                                    <h5>The Role of the Court Cards in Tarot</h5>
                                    <ul>

                                        <li >Understand how the Court Cards <span>differ from the numbered Minor Arcana</span>, representing personalities rather than situations or events.</li>

                                        <li>Learn how each Court Card fits into a Tarot spread—whether as a reflection of the querent, another person, or a state of mind.</li>




                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div className={styles.astro_syllabus_sec22_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec16_main} ${styles.astro_syllabus_sec22_main}`}>
                            <div className={styles.astro_syllabus_sec16_left_main}>
                                <div className={`${styles.learing_points}  `} >
                                    <h5>The Four Court Card Ranks and Their Archetypal Meanings</h5>
                                    <ul>

                                        <li ><strong>Knights:</strong> Action-driven, ambitious, and embodying the fiery, adventurous energy of their suit.</li>
                                        <li><strong>Queens:</strong> Emotionally mature, nurturing, and embodying the deeper, more reflective qualities of their element.</li>
                                        <li><strong>Princes:</strong> Thoughtful, curious, and embodying the intellectual and strategic aspects of their suit.</li>
                                        <li><strong>Princesses:</strong> Grounded, developing, and embodying the raw potential and learning process of each element.</li>

                                    </ul>
                                </div>
                            </div>

                            <div className={styles.astro_syllabus_sec16_right_main}>
                                <img src="/image/astro_syllabus_sec22_main_img_new.webp" alt="astro_syllabus_sec22_main_img" />
                            </div>

                        </div>
                    </div>
                </div>


                <div className={styles.astro_syllabus_sec23_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec16_main} ${styles.astro_syllabus_sec23_main}`}>


                            <div className={styles.astro_syllabus_sec16_right_main}>
                                <img src="/image/astro_syllabus_sec23_main_img_new.webp" alt="astro_syllabus_sec23_main_img" />
                            </div>

                            <div className={styles.astro_syllabus_sec16_left_main}>
                                <div className={`${styles.learing_points}  `} >
                                    <h5>The MBTI and Psychological Associations of the Court Cards</h5>
                                    <ul>

                                        <li >Explore how the <span>MBTI personality types</span> align with each Court Card, deepening their psychological interpretations.</li>
                                        <li>Learn how the <span>elements (Fire, Water, Air, Earth) and personality traits</span> create distinct behavioral patterns within the Court Cards.</li>
                                        <li>Discover how to integrate MBTI insights into Tarot readings for richer personality analysis.</li>

                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <div className={styles.astro_syllabus_sec24_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec16_main} ${styles.astro_syllabus_sec24_main}`}>

                            <div className={styles.astro_syllabus_sec16_left_main}>
                                <div className={`${styles.learing_points}  `} >
                                    <h5>Using the Court Cards in Readings</h5>
                                    <ul>

                                        <li >Learn how to <span>identify whether a Court Card represents the querent, another person, or an energy to embody.</span></li>
                                        <li>Explore techniques for interpreting <span>reversed Court Cards</span> as shadow aspects or hidden influences.</li>
                                        <li>Understand how Court Cards interact with <span>Major Arcana and Minor Arcana</span> to tell deeper, more personal stories in readings.</li>

                                    </ul>
                                </div>
                            </div>


                            <div className={styles.astro_syllabus_sec16_right_main}>
                                <img src="/image/astro_syllabus_sec24_main_img_new.webp" alt="astro_syllabus_sec24_main_img" />
                            </div>



                        </div>
                    </div>
                </div>


                <div className={styles.astro_syllabus_sec25_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec15_15A_main} ${styles.astro_syllabus_sec25_main}`}>

                            <div className={styles.astro_syllabus_sec15_15A_sub_wrp}>
                                <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />

                                <div className={`${styles.learing_points} ${styles.learing_points_block15_wrp}`} >
                                    <h5>Why Take This Course?</h5>
                                    <ul>

                                        <li ><span>Gain confidence in interpreting Court Cards</span>, often seen as the most complex part of the Tarot.</li>

                                        <li><span>Deepen your psychological understanding</span> of Tarot using MBTI and personality theory.</li>
                                        <li><span>Enhance your reading skills</span> by learning how Court Cards function within real-life situations and character dynamics.</li>
                                        <li><span>Refine your ability to distinguish personalities, motivations, and energies</span> in a Tarot spread.</li>



                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div className={styles.astro_syllabus_sec26_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec15_main} ${styles.astro_syllabus_sec26_main}`}>
                            <div className={styles.astro_syllabus_sec15_main_sub_sec}>
                                <div className={`${styles.hoa_w} ${styles.font}`}><h3>The Major Arcana</h3></div>
                                <div className={styles.syll_para}>
                                    <p>The Archetypal Path of Transformation, Mysticism, and Personal Evolution.</p>
                                </div>
                                <div className={styles.syll_para15_block_green}>
                                    <p>Course Overview</p>
                                </div>
                                <div className={`${styles.syll_para} ${styles.syll_2para}`}>
                                    <p>The Major Arcana is the heart of Tarot, representing the grand cycle of life, spiritual awakening, personal evolution, and archetypal wisdom. Each of the 22 cards in the Major Arcana holds deep significance, revealing
                                        universal truths that apply to psychology, mythology, philosophy, astrology, and mysticism.

                                    </p>
                                    <p>
                                        This course provides an in-depth study of each Major Arcana card,
                                        unraveling its historical origins, esoteric meanings, psychological
                                        interpretations, and practical applications in Tarot readings. Students will explore the symbolic journey from the boundless energy of The Fool to the mastery of The World, learning how these cards map the development of consciousness, self-discovery, and transformation.
                                    </p>
                                    <p>Through mythological storytelling, numerological analysis, planetary
                                        influences, and spiritual philosophy, this course will equip students with the knowledge to interpret the Major Arcana as a tool for divination,
                                        self-reflection, and spiritual mastery.</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <div className={styles.astro_syllabus_sec27_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec15_15A_main} ${styles.astro_syllabus_sec27_main}`}>
                            <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                                <h3> What You’ll Learn </h3>
                            </div>
                            <div className={styles.astro_syllabus_sec15_15A_sub_wrp}>
                                <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />

                                <div className={`${styles.learing_points} ${styles.learing_points_block15_wrp}`} >
                                    <h5>The Structure and Symbolism of the Major Arcana</h5>
                                    <ul>

                                        <li >Learn how the 22 cards of the Major Arcana form a narrative arc, guiding individuals through major life lessons and personal evolution.</li>

                                        <li>Explore the Fool’s Journey, a metaphorical and spiritual roadmap reflecting innocence (The Fool), discipline (The Emperor), enlightenment (The Hermit), transformation (Death), and ultimate fulfillment (The World).</li>
                                        <li>Understand the numerological order of the Major Arcana, from the boundless potential of zero (The Fool) to the completion of twenty-one (The World).</li>
                                        <li>Study the visual symbolism and iconography of each card, decoding the hidden messages within colors, figures, and elements.</li>




                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <div className={styles.astro_syllabus_sec28_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec16_main} ${styles.astro_syllabus_sec28_main}`}>
                            <div className={styles.astro_syllabus_sec16_left_main}>
                                <div className={`${styles.learing_points}  `} >
                                    <h5>The Esoteric and Mystical Foundations of the Major Arcana</h5>
                                    <ul>

                                        <li >Discover how the Major Arcana aligns with astrology, including planetary rulerships and zodiacal influences.</li>
                                        <li>Explore the Kabbalistic connections of the Major Arcana and their placement on the Tree of Life, revealing their role in spiritual ascension.</li>
                                        <li>Study the influence of alchemy and Hermeticism, learning how Tarot reflects transmutation, purification, and transformation in the spiritual process.</li>
                                        <li>Uncover historical and mythological references in the cards, including links to deities, sacred archetypes, and philosophical traditions from Egypt, Greece, and Mesopotamia.</li>
                                        <li>Understand the ritualistic and meditative uses of the Major Arcana, applying the cards as tools for introspection, guidance, and enlightenment.</li>

                                    </ul>
                                </div>
                            </div>

                            <div className={styles.astro_syllabus_sec16_right_main}>
                                <img src="/image/astro_syllabus_sec28_main_img_new.webp" alt="astro_syllabus_sec28_main_img" />
                            </div>

                        </div>
                    </div>
                </div>

                <div className={styles.astro_syllabus_sec29_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec16_main} ${styles.astro_syllabus_sec29_main}`}>


                            <div className={styles.astro_syllabus_sec16_right_main}>
                                <img src="/image/astro_syllabus_sec29_main_img_new.webp" alt="astro_syllabus_sec29_main_img" />
                            </div>

                            <div className={styles.astro_syllabus_sec16_left_main}>
                                <div className={`${styles.learing_points}  `} >
                                    <h5>The Psychological and Philosophical Interpretations</h5>
                                    <ul>

                                        <li >Examine the Major Arcana through Jungian psychology, understanding how the cards align with universal archetypes such as the Hero (The Fool), the Ruler (The Emperor), the Wise Sage (The Hermit), and the Shadow (The Devil).</li>
                                        <li>Learn how the Major Arcana reflects major life transitions, helping individuals navigate crises, change, and self-development.</li>
                                        <li>Explore philosophical perspectives embedded within the Tarot, including Stoicism, Platonic ideals, and Gnostic teachings that deepen our understanding of fate, free will, and higher purpose.</li>
                                        <li>Understand how the Major Arcana serves as a mirror of the subconscious, bringing hidden truths into awareness and fostering deep personal insight.</li>

                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className={styles.astro_syllabus_sec30_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec16_main} ${styles.astro_syllabus_sec30_main}`}>

                            <div className={styles.astro_syllabus_sec16_left_main}>
                                <div className={`${styles.learing_points}  `} >
                                    <h5>Applying the Major Arcana in Divination and Readings</h5>
                                    <ul>

                                        <li >Master the art of interpreting Major Arcana cards individually and in combination, understanding their influence in a Tarot spread.</li>
                                        <li>Learn how to differentiate between Major and Minor Arcana influences, identifying when a reading is focused on deep life lessons vs. everyday circumstances.</li>
                                        <li>Explore the role of reversed Major Arcana cards, learning how reversals shift meaning and introduce shadow aspects or blocked energies.</li>
                                        <li>Discover how the presence of multiple Major Arcana cards in a reading signifies karmic themes, spiritual awakenings, and major shifts in consciousness.</li>
                                        <li>Learn how to blend Major Arcana interpretations with astrology and numerology, enhancing the depth of a reading. Understand techniques for using the Major Arcana as a tool for self-reflection, personal empowerment, and meditation, rather than just divination.</li>

                                    </ul>
                                </div>
                            </div>


                            <div className={styles.astro_syllabus_sec16_right_main}>
                                <img src="/image/astro_syllabus_sec30_main_img_new.webp" alt="stro_syllabus_sec30_main_img" />
                            </div>



                        </div>
                    </div>
                </div>



                <div className={styles.astro_syllabus_sec31_main_mainWrp}>
                    <div className={styles.common_width}>
                        <div className={`${styles.astro_syllabus_sec15_15A_main} ${styles.astro_syllabus_sec31_main}`}>

                            <div className={styles.astro_syllabus_sec15_15A_sub_wrp}>
                                <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />

                                <div className={`${styles.learing_points} ${styles.learing_points_block15_wrp}`} >
                                    <h5>Why Take This Course?</h5>
                                    <ul>

                                        <li >Develop a deep understanding of the Major Arcana beyond surface-level interpretations.</li>

                                        <li>Gain expertise in blending Tarot with astrology, numerology, and philosophy, creating more profound readings.</li>
                                        <li>Master the ability to recognize spiritual lessons, archetypal influences, and psychological patterns in a Tarot spread.</li>
                                        <li>Use Tarot as a transformative tool, not just for fortune-telling, but for personal growth, self-awareness, and enlightenment.</li>
                                        <li>Explore the mystical dimensions of the Major Arcana and how they connect to esoteric traditions and the collective unconscious.</li>



                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>




                {/* --------------------------------block16--------------- */}




                {/* -------------------------------block17---------------------------- */}
                <div className={styles.common_width}>
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec32_main}`} >

                        <img src="/image/astro_syllabus_sec32_main_img.webp" className={styles.abs_astro_img} alt="astro_syllabus_sec32_main_img" />

                        <div className={styles.astro_syllabus_sec32_sub_main}>

                            <div className={`${styles.hoa_w} ${styles.font}`}><h3> Tarot Spreads</h3></div>

                            <div className={styles.syll_para}>
                                <p>The Archetypal Path of Transformation, Mysticism, and Personal Evolution.</p>
                            </div>

                            <div className={styles.syll_para15_block_green}>
                                <p>Course Overview</p>
                            </div>
                            <div className={`${styles.syll_para} ${styles.syll_2para}`}>
                                <p>A <span>Tarot spread</span> is the framework that gives structure to a reading, helping to organize the cards in a meaningful way to provide clarity, guidance, and
                                    insight. This course teaches students how to <span>properly use, interpret, and adapt</span> Tarot spreads for different types of questions and situations.
                                </p>
                                <p>By focusing on <span>seven core Tarot spreads</span>, ranging from simple three-card readings to advanced multi-card layouts, students will gain the skills to <span>read effectively, refine their interpretations, and provide deeper insights</span> in both personal and professional readings.</p>
                            </div>

                        </div>

                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.astro_syllabus_sec15_15A_sub_wrp}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />

                            <div className={`${styles.learing_points} ${styles.learing_points_block15_wrp}`} >
                                <h5> Foundations of Tarot Spreads and Interpretation</h5>
                                <ul>

                                    <li >Learn how <span>spread structure</span> affects the meaning of each card in a reading.</li>

                                    <li>Understand the difference between <span>short, focused spreads</span> and <span>major multi-card readings</span>.</li>
                                    <li>Explore how <span>positional meanings</span> impact card interpretations.</li>




                                </ul>
                            </div>
                        </div>



                    </div>

                </div>



                <div className={styles.tarot_spreads_new_card_block_wrp}>
                    <div className={styles.tarot_spreads_new_card_sub_block1_wrp}>
                        <div className={styles.common_width}>

                            <div className={styles.tarot_spreads_new_card_sub_block1_sec}>
                                <div className={styles.tarot_spreads_new_card_sub_block1_sec_left}>
                                    <h4>Core Tarot Spreads and Their Uses</h4>
                                    <h5>Simple & Focused Spreads</h5>
                                    <h6>3-Card Basic Question Spread  </h6>
                                    <p>Learn how to quickly interpret simple past-present-<br />
                                        future or situation-advice-outcome readings.</p>

                                    <img src="/image/first_second_third_card_img.webp" alt="first_second_third_card_img" />
                                </div>
                                <div className={styles.tarot_spreads_new_card_sub_block1_sec_right}>
                                    <h6>5-Card Complex Question Spread  </h6>
                                    <p>Discover how to expand on a question by adding more detail and depth to a reading.
                                    </p>

                                    <img src="/image/onetofive_card_img.webp" alt="onetofive_card_img" />

                                </div>

                            </div>
                        </div>
                    </div>
                </div>



                <div className={`${styles.tarot_spreads_new_card_block_wrp} ${styles.tarot_spreads_new_card_block2_wrp}`}>
                    <div className={styles.tarot_spreads_new_card_sub_block1_wrp}>
                        <div className={styles.common_width}>

                            <div className={styles.tarot_spreads_new_card_sub_block1_sec}>
                                <div className={styles.tarot_spreads_new_card_sub_block1_sec_left}>

                                    <h5>Time-Based and Predictive Spreads</h5>
                                    <h6>7-Card Six-Month Forward Review </h6>
                                    <p>Explore how to track future developments over six months, revealing trends and outcomes.</p>

                                    <img src="/image/onetoSeven_card_img.webp" alt="onetoSeven_card_img" />
                                </div>
                                <div className={styles.tarot_spreads_new_card_sub_block1_sec_right}>
                                    <h6>7-Card Horseshoe Spread (Major Read)  </h6>
                                    <p>Master this powerful, dynamic spread that provides insights into influences, challenges, and guidance for major life situations.
                                    </p>

                                    <img src="/image/onetoseven_right_cart.webp" alt="onetoseven_right_cart" />

                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <div className={styles.tarot_spreads_new_card_block3_wrpmain}>
                    <div className={styles.common_width}>
                        <div className={styles.tarot_spreads_new_card_block3_wrpmain_sub}>
                            <h5>Relationship & Personal Growth Spreads</h5>
                            <h6>10-Card Relationship Spread  </h6>
                            <p>Learn how to analyze relationships by examining energies, strengths, weaknesses, and future potential between two individuals.</p>

                            <img src="/image/onetoTen_card_img.webp" alt="onetoTen_card_img" />

                        </div>
                    </div>
                </div>



                <div className={`${styles.tarot_spreads_new_card_block_wrp} ${styles.tarot_spreads_new_card_block4_wrp}`}>
                    <div className={styles.tarot_spreads_new_card_sub_block1_wrp}>
                        <div className={styles.common_width}>

                            <div className={styles.tarot_spreads_new_card_sub_block1_sec}>
                                <div className={styles.tarot_spreads_new_card_sub_block1_sec_left}>

                                    <h5>Advanced and Multi-Layered Spreads</h5>
                                    <h6>10-Card Celtic Cross (Major Read) </h6>
                                    <p>Master one of the most famous and versatile spreads, used for in-depth readings that explore present circumstances, hidden influences, and future possibilities.</p>

                                    <img src="/image/tarot_spreads_new_card_block4_wrp_left_cart_img.webp" alt="tarot_spreads_new_card_block4_wrp_left_cart_img" />
                                </div>
                                <div className={styles.tarot_spreads_new_card_sub_block1_sec_right}>
                                    <h6>12-Card Astrological Spread (Major Read) </h6>
                                    <p>Learn how to map a reading onto the twelve houses of
                                        astrology, providing deep insights into different aspects of life, including career, relationships, spirituality, and
                                        personal growth.

                                    </p>

                                    <img src="/image/tarot_spreads_new_card_block4_wrp_right_cart_img.webp" alt="tarot_spreads_new_card_block4_wrp_right_cart_img" />

                                </div>

                            </div>
                        </div>
                    </div>
                </div>




                <div className={styles.tarot_spreads_new_card_last_blue_wrp}>
                    <div className={styles.common_width}>

                        <div className={styles.astro_syllabus_sec15_15A_sub_wrp}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />

                            <div className={`${styles.learing_points} ${styles.learing_points_block15_wrp}`} >
                                <h5>Why Take This Course?</h5>
                                <ul>

                                    <li ><span>Gain confidence in reading structured Tarot spreads</span> with precision and clarity.</li>

                                    <li><span>Learn to adapt spreads</span> for different types of questions and reading styles.</li>
                                    <li><span>Master multi-card readings</span> that reveal deeper, multi-layered meanings.</li>
                                    <li><span>Develop a professional approach</span> to Tarot reading using well-established spreads.</li>




                                </ul>
                            </div>
                        </div>
                    </div>

                </div>


                <div className={styles.common_width}>



                    {/* -------------------------------block17---------------------------- */}



                    {/* -------------------------------block11--------------------- */}
                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_sec11_main}`} >

                        <img src="/image/CD_img.webp" className={styles.abs_astro_img} alt="CD_img" />

                        <div className={`${styles.foa_w} ${styles.font}`}><h2><span>Card Divination</span> </h2></div>

                        <div className={`${styles.hoa_w} ${styles.font}`}><h3> Decans Training</h3></div>

                        <div className={styles.syll_para}>
                            <p>Gain insights into interpreting Tarot cards for spiritual guidance.</p>
                        </div>

                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>



                        <div className={styles.learing_points_wrpr}>
                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Introduction to Decans</h5>
                                <ul>

                                    <li >Understand the historical and astrological significance of dividing zodiac signs into decans.</li>
                                    <li>Explore how decans add nuance and depth to astrological interpretation.</li>


                                </ul>
                            </div>


                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Astrological Application</h5>
                                <ul>

                                    <li >Learn how to incorporate decans into natal chart readings for greater detail and precision.</li>
                                    <li>Discover how decans reveal personality subtleties and life themes.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Decans and Planetary Rulership</h5>
                                <ul>

                                    <li >Learn how each decan is governed by a specific planet, influencing its characteristics.</li>
                                    <li>Discover how these planetary rulers shape the energy of each decan within a zodiac sign.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Mystical and Mythological Connections</h5>
                                <ul>

                                    <li >Explore the symbolic and mythological associations of the decans and their planetary rulers.</li>
                                    <li>Understand the spiritual significance of decans in astrological traditions.</li>


                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Decans and Archetypes</h5>
                                <ul>

                                    <li >Delve into the unique traits and archetypal influences of each decan.</li>
                                    <li>Explore how decans offer distinct expressions of the same zodiac sign.</li>


                                </ul>
                            </div>





                        </div>



                    </div>


                    {/* -------------------------------block11--------------------- */}




































                    {/* -------------------------------rajdeep--------------------- */}

                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_mystical_main} ${styles.astro_syllabus_Mystical_Theological_Practices_main}`} >

                        <img src="/image/mystical_img2.webp" className={styles.abs_astro_img_left} alt="CD_img" />

                        <div className={`${styles.foa_w} ${styles.font}`}><h2><span>Mystical and Theological Practices</span> </h2></div>

                        <div className={`${styles.astro_syllabus_sec_left_pdd}`}>



                            <div className={`${styles.hoa_w} ${styles.font}`}><h3> Theurgy </h3></div>

                            <div className={styles.learing_points_wrpr}>
                                {/* <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" /> */}


                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>10 Days of Theurgy</h5>
                                    <ul>

                                        <li>Engage in a set of theurgical practices developed by our headmaster, aimed at deepening spiritual connection.</li>



                                    </ul>
                                </div>
                            </div>

                            <div className={`${styles.hoa_w} ${styles.font}`}><h3>Philosophical Debates</h3></div>

                            <div className={styles.learing_points_wrpr}>
                                {/* <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" /> */}


                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Carl Jung Debates</h5>
                                    <ul>

                                        <li >A recreation of Carl Jung’s arguments in favor of the divine, presented against various atheistic viewpoints.
                                        </li>



                                    </ul>
                                </div>
                            </div>

                            <div className={`${styles.hoa_w} ${styles.font}`}><h3> Core Teachings</h3></div>

                            <div className={styles.learing_points_wrpr}>
                                {/* <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" /> */}


                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Central Doctrine</h5>
                                    <ul>

                                        <li>An in-depth exploration of the complete set of central doctrines of the School, serving as the foundation for all teachings.</li>



                                    </ul>
                                </div>
                            </div>
                            <div className={styles.ATC_block4_button}>

                                <Link href="/diviner-signup" onClick={() => route.push("/diviner-signup")}><span>Get Enrolled Now</span></Link>

                            </div>

                            {/* <button></button> */}

                        </div>

                    </div>

                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_spritual_main}`} >



                        <div className={`${styles.foa_w} ${styles.font}`}><h2><span>Spiritual and Philosophical Studies</span> </h2></div>


                        <div className={`${styles.wht_Y_L_w} ${styles.font}`}>
                            <h3> What You’ll Learn </h3>
                        </div>




                        <div className={styles.learing_points_wrpr}>

                            <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" />

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>Perennial Mandalism</h5>
                                <ul>

                                    <li>Study the recurring symbolic use of mandalas in spiritual traditions.</li>



                                </ul>
                            </div>

                            <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                <h5>The Mandala</h5>
                                <ul>

                                    <li> Learn the structure, purpose, and spiritual significance of mandalas.
                                    </li>



                                </ul>
                            </div>
                        </div>







                    </div>

                    <div className={`${styles.astro_syllabus_sec} ${styles.astro_syllabus_flower_main}`} >

                        <img src="/image/flower_img.webp" className={styles.abs_astro_img} alt="CD_img" />



                        <div className={`${styles.astro_syllabus_sec_rght_pdd}`}>



                            <div className={`${styles.hoa_w} ${styles.font}`}><h3>Sacred Texts</h3></div>

                            <div className={styles.learing_points_wrpr}>
                                {/* <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" /> */}


                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>Why The Gospel of Thomas</h5>
                                    <ul>

                                        <li>Discover the spiritual teachings and hidden wisdom within the Gospel of Thomas. </li>



                                    </ul>
                                </div>
                            </div>

                            <div className={`${styles.hoa_w} ${styles.font}`}><h3>Philosophical Origins</h3></div>

                            <div className={styles.learing_points_wrpr}>
                                {/* <img src="/image/dotted_arrow_img.webp" className={`${styles.abs_dotted_arrw}`} alt="Arrow Image" /> */}


                                <div className={`${styles.learing_points} ${styles.lp_wdt}`} >
                                    <h5>The Origin of Philosophy</h5>
                                    <ul>

                                        <li>Explore the beginnings of philosophical thought, with a focus on its roots in the Upanishads.
                                        </li>



                                    </ul>
                                </div>
                            </div>



                        </div>

                    </div>
                    {/* -------------------------------rajdeep--------------------- */}





                </div>
            </div>

            <div className={styles.ATC_block6}>
                <div className={styles.common_width}>

                    <NewBlockHeader />
                    <div className={styles.ATC_block6_wrpr}>
                        <h1>Postgraduate Tools and Programs</h1>
                        <h2>One of the biggest reasons that students will love our programs is when you graduate you get <span> access to some powerful stuff! </span>  We give you incredible tools to use yourself and participate in bringing you clients!</h2>
                        <ul>
                            <li>Back office system to manage all of your clients</li>
                            <li>Calendar system for booking Tarot and Astrology clients</li>
                            <li>eCommerce programs for collecting fees (we will collect and pay you direct)</li>
                            <li>Video session technology for Astrology and Tarot with your clients</li>
                            <li>Session recordings and savings for both personal and later client review <span>Clients can share their sessions with others (more clients!)</span></li>
                            <li>Social media share tools and media</li>
                            <li>Our proprietary social advocacy program for fans and friends</li>
                            <li>Participating opportunities to take clients from our marketing programs <span>We will participate in bringing clients!</span></li>
                        </ul>
                    </div>

                </div>
            </div>


            {showOtherBlocks &&
                <>
                    {/* ==================== modal =================== */}
                    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" className="banner_modal_main">
                        <Box className="banner_modal_box">
                            <Typography id="modal-modal-description" component="div" sx={{ mt: 2 }} className="modal_banner">
                                <div className="sub_modal_banner">
                                    <span className="close_btn" onClick={handleClose}><CloseIcon /></span>
                                    <Image
                                        src={logoBanner}
                                        alt="bannerLogo"
                                        width={400}
                                        height={100}
                                        style={{ width: '100%', height: '100%' }}
                                        priority={false}
                                        placeholder="blur"
                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                                    />
                                </div>
                            </Typography>
                        </Box>
                    </Modal>


                    {/* ======================Session Modal====================== */}
                    <SessionModal
                        sessionMOdalOpen={sessionMOdalOpen}
                        setSessionMOdalOpen={setSessionMOdalOpen}
                        firstQuaterClick={firstQuaterClick}
                        setFirstQuaterClick={setFirstQuaterClick}
                        quater_id={quater_id}
                        setQuater_id={setQuater_id}
                        seduledata={seduledata}
                        setSeduledata={setSeduledata}
                    />
                </>}


        </>
    )
}
